import { useState, useEffect } from 'react'
import api from '../services/api'
import LaetitiaSite from './legacy_laetitia/LaetitiaSite'
import GenericSite from './GenericSite'
import SaasMarketingPage from './SaasMarketingPage'

export default function HomePage() {
    const [workspaceSlug, setWorkspaceSlug] = useState(null)
    const [workspaceId, setWorkspaceId] = useState(null)
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        api.get('/api/workspaces/public-profile')
           .then(res => {
               console.log("🔍 DIAGNOSTIC SAAS - Slug :", res.data.slug, "- ID :", res.data.workspace_id);
               setWorkspaceSlug(res.data.slug)
               setWorkspaceId(res.data.workspace_id)
           })
           .catch(() => {
               // Si l'appel échoue (car pas d'ID de workspace sur le domaine racine), c'est la page d'accueil SaaS !
               setWorkspaceId(null);
               setWorkspaceSlug(null);
           })
           .finally(() => setLoading(false))
    }, [ ]) // attention espace

    if (loading) return <div className="min-h-screen flex items-center justify-center"><div className="spinner border-sage-600" /></div>

    // Aiguillage multi-tenants :
    if (!workspaceId) {
        return <SaasMarketingPage />;
    }

    if (workspaceSlug === 'laetitia-lacroix' || workspaceId === 1) {
        return <LaetitiaSite />
    }

    return <GenericSite />
}
